<div class="container" [ngSwitch]="mode">
    <div *ngSwitchDefault>
        <div *ngIf="isLoading" class="spinner">
            <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width:100%">
            <tr  class="back">
              <th>Name</th>
              <th>Code</th>
              <th>
                <button class="add" mat-raised-button color="basic" (click)="addNew()">
                  Add New
                </button>
              </th>
            </tr>
            <tr class="td" *ngFor="let branch of branches">
              <td>{{branch.Branch_Name}}</td>
              <td>{{branch.Branch_Code}}</td>
              <td>
                <button mat-raised-button color="primary" (click)="view(branch)">
                  view
                </button>
              </td>
            </tr>
          </table>
    </div>
    <div *ngSwitchCase="'view'">
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr>
          <th>Branch Code</th>
          <th>Bill No</th>
          <!-- <th></th> -->
        </tr>
        <tr *ngFor="let title of titles">
          <td>{{title.branch_code}}</td>
          <td>{{title.bill_no}}</td>
          <!-- <td>
            <button mat-raised-button color="primary" (click)=" edit(title)">
              Edit
            </button>
          </td> -->
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="last">
      </div>
    </div>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create Setup</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Number Mode</mat-label>
                <input formControlName="number_mode" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Fin Year</mat-label>
                <input formControlName="fin_yr" matInput placeholder="2013-2020">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Country</mat-label>
                <mat-select formControlName="branch_code" matNativeControl required>
                  <mat-option *ngFor="let branch of branches" [value]="branch.Branch_Name">
                    {{branch.Branch_Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Bill Number</mat-label>
                <input formControlName="bill_no" matInput placeholder="">
              </mat-form-field>
          </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Edit SetUp</div>
        <div class="form">
            <span class="input">
                <mat-form-field>
                    <mat-label>Number Mode</mat-label>
                    <input formControlName="number_mode" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Fin Year</mat-label>
                    <input formControlName="fin_yr" matInput placeholder="2013-2020">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Country</mat-label>
                    <mat-select formControlName="branch_code" matNativeControl required>
                      <mat-option *ngFor="let branch of branches" [value]="branch.Branch_Name">
                        {{branch.Branch_Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Bill Number</mat-label>
                    <input formControlName="bill_no" matInput placeholder="">
                  </mat-form-field>
              </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div> 
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    
     
    </div>